<template>
  <ListeReferentiel
    ref="liste"
    titre="Assurances"
    icone="bi-shield-check"
    ressource="assurances"
    tri-defaut="ass.nom"
    :options-tri="{ Nom: 'ass.nom', 'Date de création': 'ass.createdAt', Statut: 'ass.isEnabled' }"
    placeholder="Nom ou contact…"
    unite="assurance(s)"
    vide="Aucune assurance enregistrée."
    :colonnes="5"
    :peut-creer="$store.getters.hasPermission('CONFIG_CREER_ASSURANCE')"
    libelle-creer="Nouvelle assurance"
    @creer="creation"
  >
    <template #entete>
      <th>Nom</th>
      <th class="d-none d-sm-table-cell">Contact</th>
      <th>Statut</th>
      <th>Actions</th>
    </template>
    <template #ligne="{ ligne: assurance }">
      <td>{{ assurance.nom }}</td>
      <td class="d-none d-sm-table-cell">{{ assurance.contact || '—' }}</td>
      <td>
        <span :class="['badge', assurance.isEnabled ? 'bg-success' : 'bg-secondary']">{{ assurance.isEnabled ? 'Activée' : 'Désactivée' }}</span>
      </td>
      <td>
        <div v-if="$store.getters.hasAnyPermission(['CONFIG_MODIFIER_ASSURANCE', 'CONFIG_SUPPRESSION_ASSURANCE', 'CONFIG_TARIFS_ASSURANCE'])" class="dropdown">
          <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" v-dropdown-fixed>Actions</button>
          <ul class="dropdown-menu">
            <li v-if="$store.getters.hasPermission('CONFIG_MODIFIER_ASSURANCE')"><a class="dropdown-item" href="#" @click.prevent="modifier(assurance.id)">Modifier</a></li>
            <li v-if="$store.getters.hasAnyPermission(['CONFIG_TARIFS_ASSURANCE', 'CONFIG_MODIFIER_ASSURANCE'])"><router-link class="dropdown-item" :to="`/assurances/${assurance.id}/tarifs`">Tarifs conventionnés</router-link></li>
            <li v-if="$store.getters.hasPermission('CONFIG_SUPPRESSION_ASSURANCE')"><a class="dropdown-item text-danger" href="#" @click.prevent="supprimer(assurance)">Supprimer</a></li>
          </ul>
        </div>
      </td>
    </template>
  </ListeReferentiel>
</template>

<script>
import ListeReferentiel from '@/components/commun/ListeReferentiel.vue';

export default {
  name: 'ListeAssurance',
  components: { ListeReferentiel },
  methods: {
    creation() {
      this.$router.push({ name: 'create_assurance' });
    },
    modifier(id) {
      this.$router.push({ name: 'edit_assurance', params: { id } });
    },
    supprimer(assurance) {
      this.$refs.liste.supprimer({
        id: assurance.id,
        titre: "Supprimer l'assurance",
        message: `Supprimer l'assurance « ${assurance.nom} » ?`,
        succes: 'Assurance supprimée.',
      });
    },
  },
};
</script>
